function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'oak': 'url("//double-d.art/cdn/shop/files/oak_120x.jpg?v=17104146316472392153")','white': 'url("//double-d.art/cdn/shop/files/white_120x.jpg?v=9176518357265694277")','bois-blanc': 'url("//double-d.art/cdn/shop/files/white_120x.jpg?v=9176518357265694277")','black': 'url("//double-d.art/cdn/shop/files/dark_120x.jpg?v=13714250009527027050")','bois-noir': 'url("//double-d.art/cdn/shop/files/dark_120x.jpg?v=13714250009527027050")','dark-oak': 'url("//double-d.art/cdn/shop/files/darkoak_120x.jpg?v=10499989242071432300")','oak-nature': 'url("//double-d.art/cdn/shop/files/oak-nature-303d2237_120x.png?v=6937457118608346153")','oak-dark': 'url("//double-d.art/cdn/shop/files/oak-dark-bdf44f3b_120x.png?v=7284234985550411821")','light-blue': 'url("//double-d.art/cdn/shop/files/lightblue-515501f1_120x.webp?v=2691356887755436464")','bleu-clair': 'url("//double-d.art/cdn/shop/files/lightblue-515501f1_120x.webp?v=2691356887755436464")','black-frame': 'url("//double-d.art/cdn/shop/files/dark_120x.jpg?v=13714250009527027050")','print-only': 'url("//double-d.art/cdn/shop/files/no-frame_120x.webp?v=18174410704441647333")','blackp': 'url("//double-d.art/cdn/shop/files/black-c1c66334_120x.webp?v=13140302838634768474")','chene-fonce': 'url("//double-d.art/cdn/shop/files/oak-dark-bdf44f3b_120x.png?v=7284234985550411821")','chene-naturel': 'url("//double-d.art/cdn/shop/files/oak-nature-303d2237_120x.png?v=6937457118608346153")','no-border': 'url("//double-d.art/cdn/shop/files/no-frame_120x.webp?v=18174410704441647333")','green': 'url("//double-d.art/cdn/shop/files/green-6cf84ce1_120x.webp?v=1168759761341689791")','vert': 'url("//double-d.art/cdn/shop/files/green-6cf84ce1_120x.webp?v=1168759761341689791")','red': 'url("//double-d.art/cdn/shop/files/red-0789c61e_120x.webp?v=4827882404636671733")','rouge': 'url("//double-d.art/cdn/shop/files/red-0789c61e_120x.webp?v=4827882404636671733")','grey': 'url("//double-d.art/cdn/shop/files/cashmere-grey-a70947d3_120x.webp?v=5104082185925170322")','gris': 'url("//double-d.art/cdn/shop/files/cashmere-grey-a70947d3_120x.webp?v=5104082185925170322")','teal': 'url("//double-d.art/cdn/shop/files/indian-teal-4a951454_120x.webp?v=3593310152294311295")','bleu-canard': 'url("//double-d.art/cdn/shop/files/indian-teal-4a951454_120x.webp?v=3593310152294311295")','creme': 'url("//double-d.art/cdn/shop/files/freja-ef4c1629_120x.webp?v=2948411309252458957")','cream': 'url("//double-d.art/cdn/shop/files/freja-ef4c1629_120x.webp?v=2948411309252458957")','freja': 'url("//double-d.art/cdn/shop/files/freja-ef4c1629_120x.webp?v=2948411309252458957")',};

    this.triggers = ['frame','cadre','type','framework','passe-partout','mat',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
